module.exports = __webpack_public_path__ + "static/files/deborah_levison.310871f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deborah_levison.jpg
// module id = PXxA
// module chunks = 0